import React from 'react';
import classNames from 'classnames';
import {Avatar, Chip} from 'material-ui';
import DocumentIcon from 'material-ui-icons/Description';

const RedirectsBulkDocument = ({document, onDocumentDelete, classes}) => {
    return (
        Object.keys(document).length !== 0 && <Chip
            avatar={<Avatar><DocumentIcon className={classes.documentIcon}/></Avatar>}
            className={classNames(classes.chip, 'deletable')}
            onDelete={() => {
                onDocumentDelete();
            }}
            label={document.name}
        />
    );
};

export default RedirectsBulkDocument;


// WEBPACK FOOTER //
// ./src/containers/redirects/forms/RedirectsBulkDocument.jsx